/** Canonical public brand spelling — use everywhere (navbar, footer, copy). */
export const PLATFORM_NAME = "JobScribe";

export const BRAND_WORDMARK = {
  prefix: "Job",
  accent: "Scribe",
};

export const BRAND_FONT_FAMILY = '"Inter", sans-serif';
